import React from 'react'
import { useCreateFmAndTvs } from 'hooks/fmandtvs/useCreateFmAndTvs'
import { CCol, CButton } from '@coreui/react'
import FormikControl from 'components/FormikControl'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'

const AddEvents = () => {
  const initialValues = {
    name: '',
    dob: '',
    type: '',
  }

  const { mutate: addFmOrTvs } = useCreateFmAndTvs()

  const handleFormSubmit = (data) => {
    let bodyFormData = new FormData()
    bodyFormData.append('name', data.name)
    bodyFormData.append('dob', data.dob)
    bodyFormData.append('type', data.type)
    addFmOrTvs(bodyFormData)
  }

  const validationSchema = Yup.object({
    name: Yup.string().required('Required'),
    dob: Yup.string().required('Required'),
    type: Yup.string().required('Required'),
  })

  // TODO: Store the advertisement errors into a state, then render the appropriate error message on the applicable input fields. The prop documentation of coreUI is given here: https://coreui.io/react/docs/4.0/forms/validation/. Follow it.
  return (
    <div>
      <div className="body flex-grow-1 px-3 py-3 border mt-3 rounded">
        <Formik
          validationSchema={validationSchema}
          initialValues={initialValues}
          onSubmit={(values) => {
            handleFormSubmit(values)
          }}
        >
          <Form autoComplete="off" className="row g-3">
            <FormikControl
              control="input"
              type="text"
              placeholder="Name"
              label="Name"
              name="name"
            />
            <FormikControl
              control="input"
              type="text"
              placeholder="Date of birth"
              label="Date of birth"
              name="dob"
            />
            <FormikControl
              control="select"
              placeholder="Type"
              type="text"
              label="Type"
              name="type"
              options={[
                { key: 'Celebrity', value: 'celebrity' },
                { key: 'Social Worker', value: 'social_worker' },
              ]}
            />
            <CCol xs={12}>
              <CButton type="submit" className="mt-2">
                Add Events
              </CButton>
            </CCol>
          </Form>
        </Formik>
      </div>
    </div>
  )
}

export default AddEvents
